import ReviewsStorefrontValuesBrandingEntity from "@apps/reviews/entities/ReviewsStorefrontValuesBrandingEntity";
import { InjectionKey } from "@lib/svelte-typed-context";

export const reviewsThemeContextToken: InjectionKey<ReviewsStorefrontValuesBrandingEntity> =
    Symbol("reviewsThemeContext");
